import React from "react";
import { Link } from "react-router-dom";
import styles from "./PlaygroundTile.module.css";
import { FaCode, FaNetworkWired, FaProjectDiagram } from "react-icons/fa";

const PlaygroundTiles = () => {
  const tiles = [
    {
      title: "Web Automation",
      icon: <FaCode />,
      link: "https://playground.bsparksoftwaretechnologies.com/web-automation",
      color: "#204094",
    },
    {
      title: "API Testing",
      icon: <FaNetworkWired />,
      link: "https://playground.bsparksoftwaretechnologies.com/api-testing",
      color: "#ef921a",
    },
    {
      title: "Product Management",
      icon: <FaProjectDiagram />,
      link: "https://playground.bsparksoftwaretechnologies.com/login",
      color: "#16a34a",
    },
  ];

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.heading}>
        Start testing what you learned through our playground
      </h2>
      <div className={styles.tiles}>
        {tiles.map((tile, idx) => (
          <Link
            to={tile.link}
            key={idx}
            className={styles.tile}
            style={{ borderTop: `4px solid ${tile.color}` }}
          >
            <div className={styles.icon} style={{ color: tile.color }}>
              {tile.icon}
            </div>
            <h3>{tile.title}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PlaygroundTiles;
